export const SELECT_BUDGET_CATEGORY = 'SELECT_BUDGET_CATEGORY';
export const SELECT_BUDGET_TYPE = 'SELECT_BUDGET_TYPE';

export const selectBudgetCategory = (budgetCategory, categoryTitle) => ({
  type: SELECT_BUDGET_CATEGORY,
  budgetCategory,
  categoryTitle,
});

export const selectBudgetType = (budgetType) => ({
  type: SELECT_BUDGET_TYPE,
  budgetType,
});

// =============================================================================

export const SELECT_AREA = 'SELECT_AREA';
import DataMap from '../../data/data_map.csv';

export const selectArea = (area) => {
  const i = DataMap.map(data => data.name_en).indexOf(area);
  return {
    type: SELECT_AREA,
    payload: DataMap[i],
  };
};



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/